import React, { Component, Fragment } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { SelectBox, Template } from "devextreme-react";
import { formatDate01 } from "../../helpers/globalfunctions.js";
import { LoadPanel } from "devextreme-react/load-panel";
import Highcharts from "highcharts";
import { RadioGroup } from "devextreme-react/radio-group";
import moment from "moment";
import { DataGridSkeletonPageSimpleWithTitle } from "../skeleton/GridSkeleton.js";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import {
  HighchartsTypeColumnSkeleton,
  HighchartsTypeLineSkeleton,
} from "../skeleton/DashboardSkeleton.js";
import { axiosGet, axiosPost } from "../../apis/useAxios.js";

const RideTypeLst = [
  { id: 0, name: "Both" },
  { id: 1, name: "Arrival" },
  { id: 2, name: "Departure" },
];
const DutyTypeLst = [
  { id: 0, name: "All Duty" },
  { id: 1, name: "Fly" },
  { id: 2, name: "Non Fly" },
];
const TimeSlotList = [
  { id: 0, name: "All Time" },
  { id: 1, name: "00:00 - 06:00" },
  { id: 2, name: "06:00 - 12:00" },
  { id: 3, name: "12:00 - 18:00" },
  { id: 4, name: "18:00 - 23:59" },
];

export class DashboardComponent extends Component {
  static displayName = DashboardComponent.name;

  constructor(props) {
    super(props);
    this.state = {
      isSubmited: false,
      filterFromDatetime: moment(new Date())
        .startOf("day")
        .format(`YYYY-MM-DD HH:00:00`),
      filterToDatetime: moment(new Date())
        .add(24, "hour")
        .format(`YYYY-MM-DD HH:59:59`),
      isAirlineRideApiLoading: false,
      isCompleteDashboardApiLoading: false,
      isAirlineScheduleVsActualDashboardApiLoading: false,
      tripLst: [],
      tripGridDataSource: null,
      loadPanelVisible: false,
      totalAirport: 0,
      totalRides: 0,
      totalServiceProviders: 0,
      totalCompletedRides: 0,
      totalHotelBookings: 0,
      totalDepartureCount: 0,
      totalArrivalCount: 0,
      totalNoshowCount: 0,
      totalDelayCount: 0,
      totalCancelledCount: 0,
      totalCrewRides: 0,
      scheduleVsActualData: [],
      hourlyData: [],
      reservationTitle: "Crew Transfers for Today",
      rideTypeDataSource: RideTypeLst,
      rideTypeId: 0,
      dutyTypeId: 0,
      timeSlotId: 0,
    };
    this.refDataGrid = React.createRef();
  }
  componentDidMount() {
    try {
      document.querySelector("#lblPageTitle").innerHTML = `Dashboard`;
      this.fetchGridDataOnPageLoad();
    } catch (error) {
      console.log(error);
    }
  }
  fetchGridDataOnPageLoad = async () => {
    try {
      this.setState((prev) => ({ ...prev, isAirlineRideApiLoading: true }));
      await Promise.all([
        this.getCompleteDashboard(0),
        this.getAirlineScheduleVsActualDashboard(0),
        this.getTrips(),
      ]);
      this.setState((prev) => ({ ...prev, isAirlineRideApiLoading: false }));
    } catch (error) {
      console.log(error);
    }
  };
  getCompleteDashboard = async (rideTypeId) => {
    try {
      this.setState((prev) => ({
        ...prev,
        isCompleteDashboardApiLoading: true,
      }));
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      let userId = parseInt(sessionStorage.getItem("session_userId"));
      let userName = sessionStorage.getItem("session_userName");
      const res = await axiosPost(`Dashboard/CompleteDashboard`, {
        AccountId: 0,
        AirlineCode: airlineCode,
        UserId: userId,
        UserName: userName,
        NoOfDays: 10,
        RideTypeId: rideTypeId,
      });
      const data = res?.payload ?? [];
      this.setState((prev) => ({
        ...prev,
        isCompleteDashboardApiLoading: false,
        totalAirport: data?.serviceAirportCount ?? 0,
        totalServiceProviders: data?.serviceAccountCount ?? 0,
        totalCompletedRides: data?.totalRidesCompleteCount ?? 0,
        totalRides: data?.totalRidesCount ?? 0,
        totalDepartureCount: data?.totalDepartureCount ?? 0,
        totalArrivalCount: data?.totalArrivalCount ?? 0,
        totalNoshowCount: data?.totalNoshowCount ?? 0,
        totalDelayCount: data?.totalDelayCount ?? 0,
        totalCancelledCount: data?.totalCancelledCount ?? 0,
        totalCrewRides: data?.totalCrewRides ?? 0,
        totalHotelBookings: data?.totalHotelBookingCount ?? 0,
      }));
    } catch (e) {
      this.setState((prev) => ({
        ...prev,
        isCompleteDashboardApiLoading: false,
      }));
    }
  };
  getAirlineScheduleVsActualDashboard = async (rideTypeId) => {
    try {
      this.setState((prev) => ({
        ...prev,
        isAirlineScheduleVsActualDashboardApiLoading: true,
      }));
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      let userId = parseInt(sessionStorage.getItem("session_userId"));
      let userName = sessionStorage.getItem("session_userName");
      const res = await axiosPost(`Dashboard/AirlineScheduleVsActual`, {
        AirlineCode: airlineCode,
        UserId: userId,
        UserName: userName,
        NoOfDays: 10,
        RideTypeId: rideTypeId,
      });
      const data = res?.payload ?? [];
      this.setState((prev) => ({
        ...prev,
        isAirlineScheduleVsActualDashboardApiLoading: false,
        scheduleVsActualData: data ?? [],
      }));
      this.scheduleVsActualChartRender();
      this.hourlyChartRender();
    } catch (e) {
      this.setState((prev) => ({
        ...prev,
        isAirlineScheduleVsActualDashboardApiLoading: false,
      }));
    }
  };
  getTrips = async () => {
    try {
      // var request = {};
      // request.AirlineCode = sessionStorage.getItem("session_airlineCode");
      // request.StatusId = 0;
      // request.FromDate = this.state.filterFromDatetime;
      // request.ToDate = this.state.filterToDatetime;
      // request.AirportCode = this.state.airportCode;
      // const requestParams = getRequestParams("POST", request);
      // let url = process.env.REACT_APP_API_BASE_URL + "Rides/get-rides";
      // const response = await fetch(url, requestParams);
      // const data = await response.json().then((res) => res.payload);
      const res = await axiosPost(`Rides/get-rides`, {
        AirlineCode: sessionStorage.getItem("session_airlineCode"),
        StatusId: 0,
        FromDate: this.state.filterFromDatetime,
        ToDate: this.state.filterToDatetime,
        AirportCode: this.state.airportCode,
      });
      const data = res?.payload ?? [];
      let tripLst = data?.filter((f) => f.tripStatusId !== 118) ?? [];
      this.setState((prev) => ({
        ...prev,
        tripLst: tripLst,
      }));
      this.filterTripDataGridDutyTypeWise(
        this.state.dutyTypeId,
        this.state.timeSlotId,
        tripLst,
      );
    } catch (error) {
      console.log("Error in " + this.displayName + ".getTrips function", error);
    }
  };
  filterTripDataGridDutyTypeWise = (dutyTypeId, timeSlotId, tripLst) => {
    try {
      const tripGridDataSource =
        tripLst?.filter((f) => {
          const dutyMatch =
            dutyTypeId === 0 ||
            (dutyTypeId === 1 &&
              (f.activityTypeId === 0 || f.activityTypeId === 1)) ||
            (dutyTypeId === 2 && f.activityTypeId === 2);

          let timeMatch = true;
          if (timeSlotId > 0 && f.pickupTime) {
            const d = new Date(f.pickupTime);
            const mins = d.getHours() * 60 + d.getMinutes();
            if (timeSlotId === 1) timeMatch = mins < 360;
            else if (timeSlotId === 2) timeMatch = mins >= 360 && mins < 720;
            else if (timeSlotId === 3) timeMatch = mins >= 720 && mins < 1080;
            else if (timeSlotId === 4) timeMatch = mins >= 1080;
          }

          return dutyMatch && timeMatch;
        }) ?? [];
      this.setState((prev) => ({
        ...prev,
        tripGridDataSource: tripGridDataSource,
      }));
    } catch (error) {
      console.log(error);
    }
  };
  changeSelectionRideType = async (e) => {
    try {
      this.setState({
        rideTypeId: e.value ?? 0,
      });
      await this.getCompleteDashboard(e.value);
      await this.getAirlineScheduleVsActualDashboard(e.value);
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".changeSelectionRideType function",
        error,
      );
    }
  };
  scheduleVsActualChartRender() {
    var daycategories = [];
    var totalrides = [];
    var totalcompletedrides = [];

    for (let i of this.state.scheduleVsActualData) {
      daycategories.push(i.dayName);
      totalrides.push(i.dayTotalRides);
      totalcompletedrides.push(i.totalCompleteRides);
    }

    let count1 = totalcompletedrides.filter((e) => e > 0);
    let count2 = totalrides.filter((e) => e > 0);

    Highcharts.chart("ScheduleVsActualChartContainer", {
      chart: {
        type: "column",
        animation: { duration: 800 },
      },
      title: {
        text: count1.length > 0 || count2.length > 0 ? "" : "No data available",
      },
      xAxis: {
        categories: daycategories,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: "Rides",
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y} Rides</b></td></tr>',
        footerFormat: "</table>",
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          borderRadius: 4,
          animation: { duration: 800 },
        },
      },
      series: [
        {
          name: "Total Rides",
          data: totalrides,
          color: "#b0c4de",
        },
        {
          name: "Total Completed Rides",
          data: totalcompletedrides,
          color: "#095590",
        },
      ],
    });
  }
  hourlyChartRender() {
    var daycategories = [];
    var gtperformancedata = [];

    for (let i of this.state.scheduleVsActualData) {
      daycategories.push(i.dayName);
      gtperformancedata.push(i.gtPerformance);
    }

    let count = gtperformancedata.filter((e) => e > 0);

    Highcharts.chart("HourlyChartContainer", {
      chart: {
        type: "line",
        animation: { duration: 800 },
      },
      title: {
        text: count.length > 0 ? "" : "No data available",
      },
      xAxis: {
        categories: daycategories,
      },
      yAxis: {
        title: {
          text: "GT Performance (%)",
        },
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
          },
          enableMouseTracking: true,
          marker: { radius: 5, symbol: "circle" },
          animation: { duration: 800 },
        },
      },
      series: [
        {
          name: "GT Performance",
          data: gtperformancedata,
          color: "#095590",
        },
      ],
      lang: {
        noData: "no data!",
      },
      noData: {
        position: {
          x: 0,
          y: 0,
          align: "center",
          verticalAlign: "middle",
        },
      },
    });
  }

  AirportGridShow = () => {
    sessionStorage.setItem("session_PageName", "Airport");
    window.location.href = "/airport";
  };
  handleGridChanges = async (e, ids) => {
    e.preventDefault();
    let filterFromDatetime = moment(new Date())
      .startOf("day")
      .format(`YYYY-MM-DD HH:00:00`);
    let filterToDatetime = moment(new Date())
      .add(24, "hour")
      .format(`YYYY-MM-DD HH:59:59`);
    if (ids === 1) {
      filterToDatetime = moment(new Date())
        .endOf("day")
        .format(`YYYY-MM-DD HH:59:59`);
    }
    let airlineCode = sessionStorage.getItem("session_airlineCode");
    this.setState((prev) => ({
      ...prev,
      loadPanelVisible: true,
      filterFromDatetime: filterFromDatetime,
      filterToDatetime: filterToDatetime,
    }));

    const res = await axiosPost(`Rides/AirlineRides`, {
      AirlineCode: airlineCode,
      StatusId: 0,
      FromDate: filterFromDatetime,
      ToDate: filterToDatetime,
      AirportCode: this.state.airportCode,
      UserId: sessionStorage.getItem("session_userId"),
    });
    const data = res?.payload ?? [];
    let tripLst = data.filter((f) => f.tripStatusId !== 118) ?? [];
    if (ids === 1) {
      var CrewTransfer = [];
      CrewTransfer =
        tripLst != null ? tripLst.filter((e) => e.tripStatusId !== 118) : [];
      this.setState((prev) => ({
        ...prev,
        tripGridDataSource: CrewTransfer,
        loadPanelVisible: false,
        reservationTitle: "Crew Transfers for Today",
      }));
    } else if (ids === 2) {
      var DepartureRides = [];
      DepartureRides =
        tripLst != null ? tripLst.filter((e) => e.rideTypeId === 2) : [];
      this.setState((prev) => ({
        ...prev,
        tripGridDataSource: DepartureRides,
        loadPanelVisible: false,
        reservationTitle: "Departure Rides",
      }));
    } else if (ids === 3) {
      var ArrivalRides = [];
      ArrivalRides =
        tripLst != null ? tripLst.filter((e) => e.rideTypeId === 1) : [];
      this.setState((prev) => ({
        ...prev,
        tripGridDataSource: ArrivalRides,
        loadPanelVisible: false,
        reservationTitle: "Arrival",
      }));
    } else if (ids === 4) {
      var NoShowRides = [];
      NoShowRides =
        tripLst != null
          ? tripLst.filter(
              (e) => e.tripStatusId === 109 || e.tripStatusId === 110,
            )
          : [];
      this.setState((prev) => ({
        ...prev,
        tripGridDataSource: NoShowRides,
        loadPanelVisible: false,
        reservationTitle: "No Show Rides",
      }));
    } else if (ids === 5) {
      var CancelledRides = [];
      CancelledRides =
        tripLst != null ? tripLst.filter((e) => e.tripStatusId === 111) : [];
      this.setState((prev) => ({
        ...prev,
        tripGridDataSource: CancelledRides,
        loadPanelVisible: false,
        reservationTitle: "Cancelled Rides",
      }));
    } else if (ids === 6) {
      var DelayPickupRide = [];
      DelayPickupRide =
        tripLst != null
          ? tripLst.filter((e) => e.locationTime > e.pickupTime)
          : [];
      this.setState((prev) => ({
        ...prev,
        tripGridDataSource: DelayPickupRide,
        loadPanelVisible: false,
        reservationTitle: "Delay Pickup",
      }));
    } else {
      var CompletedRides = [];
      CompletedRides =
        tripLst != null
          ? tripLst.filter(
              (e) => e.tripStatusId === 116 && e.tripStatusId !== 118,
            )
          : [];
      this.setState((prev) => ({
        ...prev,
        tripGridDataSource: CompletedRides,
        loadPanelVisible: false,
        reservationTitle: "Executed Crew Transfers",
      }));
    }
    this.setState((prev) => ({
      ...prev,
      loadPanelVisible: false,
    }));
  };

  render() {
    const renderPaxEmployeeGridCell = (data) => {
      if (data.data.paxName.includes("[")) {
        var position =
          data.data.paxName.split(/[\s`,]+/)[
            data.data.paxName.split(/[\s`,]+/).length - 1
          ];
        var _d = position.substring(0, position.lastIndexOf("-") + 1);
        var _p = _d.replace("[", "");
        var _paxName = _p.replace("-", "");
        var _pax =
          data.data.paxName.split(/[\s`,]+/)[
            data.data.paxName.split(/[\s`,]+/).length - 2
          ] +
          " " +
          data.data.paxName.split(/[\s`,]+/)[
            data.data.paxName.split(/[\s`,]+/).length - 3
          ] +
          "- " +
          _paxName;

        return (
          <div className="mergeData ellipsis">
            <span className="text-muted">
              <i className="fa fa-user"></i>
            </span>{" "}
            <span className="text-muted"></span>
            {_pax}
            <br />
            <span className="text-muted">
              <i className="fas fa-id-badge"></i>
            </span>{" "}
            <span className="text-muted"></span>
            {data.data.employeeNo}
          </div>
        );
      } else {
        return (
          <div className="mergeData ellipsis">
            <span className="text-muted">
              <i className="fa fa-user"></i>
            </span>{" "}
            <span className="text-muted"></span>
            {data.data.paxName}
            <br />
            <span className="text-muted">
              <i className="fas fa-id-badge"></i>
            </span>{" "}
            <span className="text-muted"></span>
            {data.data.employeeNo}
          </div>
        );
      }
    };

    const renderReportingDebreifingGridCell = (data) => {
      if (data.data.dutyReportingTime) {
        return (
          <div className="mergeData ellipsis">
            <span className="text-muted"></span>{" "}
            <span className="text-muted">R -</span>
            {data.data.dutyReportingTime
              ? formatDate01(data.data.dutyReportingTime, "dd/MM/yy hh:mm")
              : ""}
            {/* <br />
                <span className='text-muted'></span> <span className='text-muted'>D - </span>{data.data.deBriefingTime != null ? formatDate01(data.data.deBriefingTime, 'dd/MM/yy hh:mm') :''} */}
          </div>
        );
      } else {
        return (
          <div className="mergeData ellipsis">
            <span className="text-muted"></span>{" "}
            <span className="text-muted">D - </span>
            {data.data.deBriefingTime
              ? formatDate01(data.data.deBriefingTime, "dd/MM/yy hh:mm")
              : ""}
          </div>
        );
      }
    };

    const renderPickupTimeGridCell = (data) => {
      return (
        <div className="mergeData ellipsis">
          <span className="text-muted">
            <i className="fa fa-clock" />
          </span>{" "}
          <span className="text-muted">Pickup -</span>
          {data.data.pickupTime
            ? formatDate01(data.data.pickupTime, "dd/MM/yy hh:mm")
            : "N/A"}
          <br />
          <span className="text-muted">
            <i className="fa fa-clock" />
          </span>{" "}
          <span className="text-muted">On Loc.-</span>
          {data.data.locationTime
            ? formatDate01(data.data.locationTime, "dd/MM/yy hh:mm")
            : "N/A"}
        </div>
      );
    };
    return (
      <>
        <style>{`
          /* ── Dashboard ── */
          .db-summary-card {
            transition: transform 0.15s ease, box-shadow 0.15s ease;
            cursor: default;
          }
          .db-summary-card:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 24px rgba(0,0,0,0.22) !important;
          }
          .db-chart-card {
            border-radius: 10px !important;
            overflow: hidden !important;
            border: 1px solid #e8d5c4 !important;
            box-shadow: 0 2px 12px rgba(142,100,72,0.10) !important;
            margin-bottom: 10px !important;
          }
          .db-chart-header {
            background: linear-gradient(135deg, #fff0e6 0%, #fff0e6 100%) !important;
            padding: 0.55rem 1rem !important;
            min-height: 46px !important;
          }
          .db-chart-header h5 { color: #000000 !important; font-size: 0.84rem !important; font-weight: 600 !important; margin-bottom: 0 !important; }
          .db-chart-header .dx-widget { color: #fff !important; }
          .db-grid-card {
            border-radius: 10px !important;
            overflow: hidden !important;
            border: 1px solid #e8d5c4 !important;
            box-shadow: 0 2px 12px rgba(142,100,72,0.10) !important;
          }
          .db-grid-card .dx-header-row td {
            background-color: #fff036e!important;
            color: #000000 !important;
            font-size: 0.76rem !important;
            font-weight: 600 !important;
            letter-spacing: 0.02em !important;
            border-color: rgba(255,255,255,0.15) !important;
          }
          .db-grid-card .dx-datagrid-filter-row td { background-color: #f5ede4 !important; }
          .db-grid-card .dx-toolbar {
            background: #fdf7f2 !important;
            border-bottom: 1px solid #e8d5c4 !important;
            padding: 0.35rem 0.75rem !important;
          }
        `}</style>
        <div>
          <div className="row m-0 mb-1">
            {this.state.isCompleteDashboardApiLoading && (
              <BookingSummaryCount />
            )}
            {!this.state.isCompleteDashboardApiLoading && (
              <>
                {/* Airport Serviced — Blue */}
                <div className="col-12 col-sm-6 col-md-3 px-2">
                  <div
                    className="card border-0 mb-2 db-summary-card"
                    style={{
                      background: "#2196F3",
                      borderRadius: "12px",
                      position: "relative",
                      overflow: "hidden",
                      boxShadow: "0 4px 15px rgba(33,150,243,0.35)",
                    }}
                  >
                    <img
                      src="../assets/img/bg-akasa-symbol.png"
                      alt=""
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        height: "100%",
                        opacity: 0.18,
                      }}
                    />
                    <div
                      className="card-body d-flex align-items-center gap-4 p-3"
                      style={{ position: "relative", zIndex: 1 }}
                    >
                      <i
                        className="fas fa-plane-departure"
                        style={{
                          fontSize: "2rem",
                          color: "#fff",
                          flexShrink: 0,
                          marginRight: "0.75rem",
                        }}
                      ></i>
                      <div>
                        <div
                          style={{
                            fontSize: "0.82rem",
                            color: "#fff",
                            fontWeight: 500,
                          }}
                        >
                          Airport Serviced
                        </div>
                        <div
                          style={{
                            fontSize: "2rem",
                            fontWeight: 700,
                            color: "#fff",
                            lineHeight: 1.1,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={this.AirportGridShow}
                        >
                          {this.state.totalAirport}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Crew Transfers — Yellow */}
                <div className="col-12 col-sm-6 col-md-3 px-2">
                  <div
                    className="card border-0 mb-2 db-summary-card"
                    style={{
                      background: "#FFC107",
                      borderRadius: "12px",
                      position: "relative",
                      overflow: "hidden",
                      boxShadow: "0 4px 15px rgba(255,193,7,0.35)",
                    }}
                  >
                    <img
                      src="../assets/img/bg-akasa-symbol.png"
                      alt=""
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        height: "100%",
                        opacity: 0.18,
                      }}
                    />
                    <div
                      className="card-body d-flex align-items-center gap-4 p-3"
                      style={{ position: "relative", zIndex: 1 }}
                    >
                      <i
                        className="fas fa-car-alt"
                        style={{
                          fontSize: "2rem",
                          color: "#fff",
                          flexShrink: 0,
                          marginRight: "0.75rem",
                        }}
                      ></i>
                      <div>
                        <div
                          style={{
                            fontSize: "0.82rem",
                            color: "#fff",
                            fontWeight: 500,
                          }}
                        >
                          Crew Transfers for Today
                        </div>
                        <div
                          style={{
                            fontSize: "2rem",
                            fontWeight: 700,
                            color: "#fff",
                            lineHeight: 1.1,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            this.handleGridChanges(e, 1);
                          }}
                        >
                          {this.state.totalCrewRides}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Departure — Purple */}
                <div className="col-12 col-sm-6 col-md-3 px-2">
                  <div
                    className="card border-0 mb-2 db-summary-card"
                    style={{
                      background: "#7B1FA2",
                      borderRadius: "12px",
                      position: "relative",
                      overflow: "hidden",
                      boxShadow: "0 4px 15px rgba(123,31,162,0.35)",
                    }}
                  >
                    <img
                      src="../assets/img/bg-akasa-symbol.png"
                      alt=""
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        height: "100%",
                        opacity: 0.18,
                      }}
                    />
                    <div
                      className="card-body d-flex align-items-center gap-4 p-3"
                      style={{ position: "relative", zIndex: 1 }}
                    >
                      <i
                        className="fas fa-plane-departure"
                        style={{
                          fontSize: "2rem",
                          color: "#fff",
                          flexShrink: 0,
                          marginRight: "0.75rem",
                        }}
                      ></i>
                      <div>
                        <div
                          style={{
                            fontSize: "0.82rem",
                            color: "#fff",
                            fontWeight: 500,
                          }}
                        >
                          Departure
                        </div>
                        <div
                          style={{
                            fontSize: "2rem",
                            fontWeight: 700,
                            color: "#fff",
                            lineHeight: 1.1,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            this.handleGridChanges(e, 2);
                          }}
                        >
                          {this.state.totalDepartureCount}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Arrival — Light Purple */}
                <div className="col-12 col-sm-6 col-md-3 px-2">
                  <div
                    className="card border-0 mb-2 db-summary-card"
                    style={{
                      background: "#AB47BC",
                      borderRadius: "12px",
                      position: "relative",
                      overflow: "hidden",
                      boxShadow: "0 4px 15px rgba(171,71,188,0.35)",
                    }}
                  >
                    <img
                      src="../assets/img/bg-akasa-symbol.png"
                      alt=""
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        height: "100%",
                        opacity: 0.18,
                      }}
                    />
                    <div
                      className="card-body d-flex align-items-center gap-4 p-3"
                      style={{ position: "relative", zIndex: 1 }}
                    >
                      <i
                        className="fas fa-plane-arrival"
                        style={{
                          fontSize: "2rem",
                          color: "#fff",
                          flexShrink: 0,
                          marginRight: "0.75rem",
                        }}
                      ></i>
                      <div>
                        <div
                          style={{
                            fontSize: "0.82rem",
                            color: "#fff",
                            fontWeight: 500,
                          }}
                        >
                          Arrival
                        </div>
                        <div
                          style={{
                            fontSize: "2rem",
                            fontWeight: 700,
                            color: "#fff",
                            lineHeight: 1.1,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            this.handleGridChanges(e, 3);
                          }}
                        >
                          {this.state.totalArrivalCount}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* No Show — Gray */}
                <div className="col-12 col-sm-6 col-md-3 px-2">
                  <div
                    className="card border-0 mb-2 db-summary-card"
                    style={{
                      background: "#9E9E9E",
                      borderRadius: "12px",
                      position: "relative",
                      overflow: "hidden",
                      boxShadow: "0 4px 15px rgba(158,158,158,0.35)",
                    }}
                  >
                    <img
                      src="../assets/img/bg-akasa-symbol.png"
                      alt=""
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        height: "100%",
                        opacity: 0.18,
                      }}
                    />
                    <div
                      className="card-body d-flex align-items-center gap-4 p-3"
                      style={{ position: "relative", zIndex: 1 }}
                    >
                      <i
                        className="fas fa-eye-slash"
                        style={{
                          fontSize: "2rem",
                          color: "#fff",
                          flexShrink: 0,
                          marginRight: "0.75rem",
                        }}
                      ></i>
                      <div>
                        <div
                          style={{
                            fontSize: "0.82rem",
                            color: "#fff",
                            fontWeight: 500,
                          }}
                        >
                          No Show
                        </div>
                        <div
                          style={{
                            fontSize: "2rem",
                            fontWeight: 700,
                            color: "#fff",
                            lineHeight: 1.1,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            this.handleGridChanges(e, 4);
                          }}
                        >
                          {this.state.totalNoshowCount}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Cancelled Rides — Red */}
                <div className="col-12 col-sm-6 col-md-3 px-2">
                  <div
                    className="card border-0 mb-2 db-summary-card"
                    style={{
                      background: "#EF5350",
                      borderRadius: "12px",
                      position: "relative",
                      overflow: "hidden",
                      boxShadow: "0 4px 15px rgba(239,83,80,0.35)",
                    }}
                  >
                    <img
                      src="../assets/img/bg-akasa-symbol.png"
                      alt=""
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        height: "100%",
                        opacity: 0.18,
                      }}
                    />
                    <div
                      className="card-body d-flex align-items-center gap-4 p-3"
                      style={{ position: "relative", zIndex: 1 }}
                    >
                      <i
                        className="fas fa-times"
                        style={{
                          fontSize: "2rem",
                          color: "#fff",
                          flexShrink: 0,
                          marginRight: "0.75rem",
                        }}
                      ></i>
                      <div>
                        <div
                          style={{
                            fontSize: "0.82rem",
                            color: "#fff",
                            fontWeight: 500,
                          }}
                        >
                          Cancelled Rides
                        </div>
                        <div
                          style={{
                            fontSize: "2rem",
                            fontWeight: 700,
                            color: "#fff",
                            lineHeight: 1.1,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            this.handleGridChanges(e, 5);
                          }}
                        >
                          {this.state.totalCancelledCount}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Delay Pickup — Red */}
                <div className="col-12 col-sm-6 col-md-3 px-2">
                  <div
                    className="card border-0 mb-2 db-summary-card"
                    style={{
                      background: "#EF5350",
                      borderRadius: "12px",
                      position: "relative",
                      overflow: "hidden",
                      boxShadow: "0 4px 15px rgba(239,83,80,0.35)",
                    }}
                  >
                    <img
                      src="../assets/img/bg-akasa-symbol.png"
                      alt=""
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        height: "100%",
                        opacity: 0.18,
                      }}
                    />
                    <div
                      className="card-body d-flex align-items-center gap-4 p-3"
                      style={{ position: "relative", zIndex: 1 }}
                    >
                      <i
                        className="fas fa-user-clock"
                        style={{
                          fontSize: "2rem",
                          color: "#fff",
                          flexShrink: 0,
                          marginRight: "0.75rem",
                        }}
                      ></i>
                      <div>
                        <div
                          style={{
                            fontSize: "0.82rem",
                            color: "#fff",
                            fontWeight: 500,
                          }}
                        >
                          Delay Pickup
                        </div>
                        <div
                          style={{
                            fontSize: "2rem",
                            fontWeight: 700,
                            color: "#fff",
                            lineHeight: 1.1,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            this.handleGridChanges(e, 6);
                          }}
                        >
                          {this.state.totalDelayCount}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Executed Crew Transfers — Green */}
                <div className="col-12 col-sm-6 col-md-3 px-2">
                  <div
                    className="card border-0 mb-2 db-summary-card"
                    style={{
                      background: "#4CAF50",
                      borderRadius: "12px",
                      position: "relative",
                      overflow: "hidden",
                      boxShadow: "0 4px 15px rgba(76,175,80,0.35)",
                    }}
                  >
                    <img
                      src="../assets/img/bg-akasa-symbol.png"
                      alt=""
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        height: "100%",
                        opacity: 0.18,
                      }}
                    />
                    <div
                      className="card-body d-flex align-items-center gap-4 p-3"
                      style={{ position: "relative", zIndex: 1 }}
                    >
                      <i
                        className="fas fa-exchange-alt"
                        style={{
                          fontSize: "2rem",
                          color: "#fff",
                          flexShrink: 0,
                          marginRight: "0.75rem",
                        }}
                      ></i>
                      <div>
                        <div
                          style={{
                            fontSize: "0.82rem",
                            color: "#fff",
                            fontWeight: 500,
                          }}
                        >
                          Executed Crew Transfers
                        </div>
                        <div
                          style={{
                            fontSize: "2rem",
                            fontWeight: 700,
                            color: "#fff",
                            lineHeight: 1.1,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            this.handleGridChanges(e, 7);
                          }}
                        >
                          {this.state.totalCompletedRides}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="row m-0">
            <div className="col-12 col-sm-12 col-md-12 px-0 pb-0">
              <div className="row mx-0 mb-0">
                <div className="col-6 col-sm-6 col-md-6 px-2">
                  <div className="card border-0 db-chart-card">
                    <div
                      className="card-header border-0 d-flex align-items-center justify-content-between flex-wrap gap-2 db-chart-header"
                      style={{}}
                    >
                      <h5
                        style={{
                          color: "#fff",
                          fontWeight: 600,
                          marginBottom: 0,
                          fontSize: "0.85rem",
                        }}
                      >
                        Scheduled Vs Actual Pick-up Time
                      </h5>
                      <div style={{ color: "#000000" }}>
                        <RadioGroup
                          id="radio-group-with-selection"
                          dataSource={this.state.rideTypeDataSource}
                          layout="horizontal"
                          value={this.state.rideTypeId}
                          defaultValue={this.state.rideTypeId}
                          valueExpr="id"
                          displayExpr="name"
                          onValueChanged={this.changeSelectionRideType}
                          itemRender={(item) => (
                            <span
                              style={{ color: "#000000", fontSize: "0.82rem" }}
                            >
                              {item.name}
                            </span>
                          )}
                        />
                      </div>
                    </div>
                    <div className="card-body" style={{ padding: "1rem" }}>
                      <div className="tab-content p-0">
                        {this.state
                          .isAirlineScheduleVsActualDashboardApiLoading && (
                          <HighchartsTypeColumnSkeleton />
                        )}
                        {!this.state
                          .isAirlineScheduleVsActualDashboardApiLoading && (
                          <div
                            id="ScheduleVsActualChartContainer"
                            style={{ height: "225px" }}
                          ></div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-sm-6 col-md-6 px-2">
                  <div className="card border-0 db-chart-card">
                    <div
                      className="card-header border-0 db-chart-header"
                      style={{}}
                    >
                      <h5
                        style={{
                          color: "#fff",
                          fontWeight: 600,
                          marginBottom: 0,
                          fontSize: "0.85rem",
                        }}
                      >
                        On Time Performance
                      </h5>
                    </div>
                    <div className="card-body" style={{ padding: "1rem" }}>
                      <div className="tab-content p-0">
                        {this.state
                          .isAirlineScheduleVsActualDashboardApiLoading && (
                          <HighchartsTypeLineSkeleton />
                        )}
                        {!this.state
                          .isAirlineScheduleVsActualDashboardApiLoading && (
                          <div
                            id="HourlyChartContainer"
                            style={{ height: "225px" }}
                          ></div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12 px-2">
              <div className="card border-0 db-grid-card">
                <div className="card-body p-0">
                  {this.state.isAirlineRideApiLoading && (
                    <DataGridSkeletonPageSimpleWithTitle />
                  )}
                  {!this.state.isAirlineRideApiLoading && (
                    <DataGrid
                      ref={this.refDataGrid}
                      dataSource={this.state.tripGridDataSource}
                      // dataSource={
                      //   new DataSource({
                      //     store: this.state.tripGridDataSource?.filter(
                      //       (f) =>
                      //         this.state.dutyTypeId === 0 ||
                      //         (this.state.dutyTypeId === 1 &&
                      //           (f.activityTypeId === 0 ||
                      //             f.activityTypeId === 1)) ||
                      //         (this.state.dutyTypeId === 2 &&
                      //           f.activityTypeId === 2)
                      //     ),
                      //   })
                      // }
                      columnsAutoWidth={true}
                      showColumnLines={true}
                      showRowLines={true}
                      showBorders={true}
                      rowAlternationEnabled={true}
                      hoverStateEnabled={true}
                      allowColumnResizing={true}
                      repaintChangesOnly={true}
                      onCellPrepared={(e) => {
                        if (e.rowType === "header") {
                          e.cellElement.style.backgroundColor = "#fff0e6";
                          e.cellElement.style.color = "#000000";
                        }
                      }}
                      onRowPrepared={(e) => {
                        if (e.rowType === "data") {
                          if (e.data.tripStatusId === 101) {
                            e.rowElement.style.backgroundColor = "#ffffff";
                            if (e.data.activityTypeId === 2) {
                              e.rowElement.style.backgroundColor = "#f2f2f2";
                            }
                          } else if (e.data.tripStatusId === 111) {
                            e.rowElement.style.backgroundColor = "#f2f2f2";
                            e.rowElement.style.foregroundColor = "#ffffff";
                          } else if (e.data.tripStatusId === 104) {
                            e.rowElement.style.backgroundColor = "#FFFB77";
                          } else if (e.data.tripStatusId === 103) {
                            e.rowElement.style.backgroundColor = "#f2f2f2";
                          } else if (e.data.tripStatusId === 105) {
                            e.rowElement.style.backgroundColor = "#f2f2f2";
                          } else if (e.data.tripStatusId === 107) {
                            e.rowElement.style.backgroundColor = "#FFFF01";
                          } else if (e.data.tripStatusId === 108) {
                            e.rowElement.style.backgroundColor = "#D4FFD4";
                          } else if (e.data.tripStatusId === 109) {
                            e.rowElement.style.backgroundColor = "#eabdf5";
                            e.rowElement.style.foregroundColor = "#ffffff";
                          } else if (e.data.tripStatusId === 110) {
                            e.rowElement.style.backgroundColor = "#eabdf5";
                            e.rowElement.style.foregroundColor = "#ffffff";
                          } else if (e.data.tripStatusId === 116) {
                            e.rowElement.style.backgroundColor = "#01B050";
                            e.rowElement.style.foregroundColor = "#ffffff";
                          }
                        }
                      }}
                      onToolbarPreparing={(e) => {
                        e.toolbarOptions.items.unshift(
                          {
                            location: "before",
                            template: "toolbarDataFilterTemplate",
                          },
                          {
                            location: "before",
                            template: "toolbarDataDutyTypeDropdownTemplate",
                          },
                          {
                            location: "before",
                            template: "toolbarTimeSlotDropdownTemplate",
                          },
                          {
                            location: "after",
                            widget: "dxButton",
                            options: {
                              icon: "refresh",
                              onClick: async (e) => {
                                try {
                                  this.refDataGrid.current.instance.beginCustomLoading();
                                  e.component.option(
                                    "icon",
                                    "fas fa-spinner fa-spin",
                                  );
                                  await new Promise((resolve) =>
                                    setTimeout(resolve, 1000),
                                  ); // 0.5 sec
                                  await this.getTrips();
                                  e.component.option("icon", "refresh");
                                } catch (error) {
                                  console.log(error);
                                } finally {
                                  this.refDataGrid.current.instance.endCustomLoading();
                                }
                              },
                            },
                          },
                        );
                      }}
                    >
                      <Column
                        dataField="activityType"
                        caption="Duty Type"
                        allowSearch={true}
                        headerFilter={{ allowSearch: true }}
                        width={100}
                      />
                      <Column
                        dataField="activityDisplay"
                        caption="Activity"
                        allowSearch={true}
                        headerFilter={{ allowSearch: true }}
                        alignment={"left"}
                        width={150}
                        // cellRender={(data) => {
                        //   if (data.data.activityTypeId === 2) {
                        //     return (
                        //       <div className="mergeData ellipsis">
                        //         <span className="text-muted">
                        //           <i className="fas fa-map-marker-alt fa-xs" />
                        //         </span>{" "}
                        //         {`${data.data?.activityCode ?? ""}`}
                        //         {data.data?.activityLocationCode && (
                        //           <>
                        //             <br />
                        //             <span className="text-muted">
                        //               <i className="fas fa-building fa-xs"></i>
                        //             </span>{" "}
                        //             {`${data.data?.activityLocationCode ?? ""}`}
                        //           </>
                        //         )}
                        //       </div>
                        //     );
                        //   } else {
                        //     if (data.data.rideTypeId === 1) {
                        //       return (
                        //         <div className="mergeData ellipsis">
                        //           <span className="text-muted">
                        //             <i className="fas fa-plane-arrival"></i>
                        //           </span>{" "}
                        //           <span>{data.data.activityDisplay}</span>
                        //         </div>
                        //       );
                        //     }
                        //     return (
                        //       <div className="mergeData ellipsis">
                        //         <span className="text-muted">
                        //           <i className="fas fa-plane-departure"></i>
                        //         </span>{" "}
                        //         <span>{data.data.activityDisplay}</span>
                        //       </div>
                        //     );
                        //   }
                        // }}
                        cellRender={(data) => {
                          if (data.data?.activityLocationCode) {
                            return (
                              <div className="mergeData ellipsis">
                                <span className="text-muted">
                                  <i className="fas fa-map-marker-alt fa-xs" />
                                </span>{" "}
                                {`${data.data?.activityCode ?? ""}`}
                                <br />
                                <span className="text-muted">
                                  <i className="fas fa-building fa-xs"></i>
                                </span>{" "}
                                {`${data.data?.activityLocationCode ?? ""}`}
                              </div>
                            );
                          }
                          return (
                            <div className="mergeData ellipsis">
                              <span className="text-muted">
                                <i className="fas fa-plane-departure"></i>
                              </span>{" "}
                              <span>{data.data.activityDisplay}</span>
                            </div>
                          );
                        }}
                      />
                      <Column
                        dataField="flightTerminal"
                        caption="Terminal"
                        allowSearch={true}
                        headerFilter={{ allowSearch: true }}
                        width={100}
                        alignment={"center"}
                      />
                      <Column
                        dataField="flightActivityDateTime"
                        caption="Flight/Activity Time"
                        allowSearch={true}
                        headerFilter={{ allowSearch: true }}
                        dataType="datetime"
                        format="dd/MM/yy HH:mm"
                        width={150}
                      />
                      <Column
                        dataField="paxName"
                        caption="Crew / Emp #"
                        allowSearch={true}
                        headerFilter={{ allowSearch: true }}
                        width={150}
                        cellRender={renderPaxEmployeeGridCell}
                      />
                      {/* <Column
                        dataField="crewPosition"
                        caption="Rank"
                        allowSearch={true}
                        headerFilter={{ allowSearch: true }}
                        alignment={"center"}
                        width={100}
                      /> */}
                      <Column
                        dataField="reportingDebriefingTime"
                        caption="Reporting / Debrief Time"
                        allowSearch={true}
                        headerFilter={{ allowSearch: true }}
                        width={180}
                        cellRender={renderReportingDebreifingGridCell}
                      />
                      <Column
                        dataField="pickupTime"
                        caption="Pickup Time"
                        allowSearch={true}
                        headerFilter={{ allowSearch: true }}
                        dataType="datetime"
                        width={200}
                        cellRender={renderPickupTimeGridCell}
                      />
                      <Column
                        dataField="pickupLocation"
                        caption="Pickup / Drop Off"
                        allowSearch={true}
                        headerFilter={{ allowSearch: true }}
                        width={300}
                        cellRender={(data) => {
                          return (
                            <div className="mergeData ellipsis">
                              <span className="text-success">
                                <i className="fas fa-map-marker-alt"></i>
                              </span>
                              <span className="text-muted"></span>{" "}
                              {data.data.pickupLocation}
                              <br />
                              <span className="text-danger">
                                <i className="fas fa-map-marker-alt"></i>
                              </span>
                              <span className="text-muted"></span>{" "}
                              {data.data.dropoffLocation}
                            </div>
                          );
                        }}
                      />
                      {/* <Column dataField="doStreet" caption="" allowSearch={true} allowFiltering={false} allowSorting={true} width={280} /> */}
                      <Column
                        dataField="driverName"
                        caption="Driver / Vehicle"
                        allowSearch={true}
                        headerFilter={{ allowSearch: true }}
                        width={200}
                        cellRender={(data) => {
                          return (
                            <div className="mergeData ellipsis">
                              <i className="fa fa-user-alt" />
                              <span className="text-muted"></span>{" "}
                              {(data.data.driverName ?? "").trim() !== ""
                                ? data.data.driverName
                                : "N/A"}
                              <br />
                              <i className="fa fa-car-alt" />
                              <span className="text-muted"></span>{" "}
                              {(data.data.vehicleNo ?? "") !== ""
                                ? data.data.vehicleNo
                                : "N/A"}
                            </div>
                          );
                        }}
                      />
                      <Column
                        dataField="tripStatus"
                        caption="Status"
                        allowSearch={true}
                        headerFilter={{ allowSearch: true }}
                        width={120}
                      />
                      {/* <Column dataField="driverName" caption="" allowSearch={true} allowFiltering={false} allowSorting={true} width={125} /> */}
                      {/* <Column dataField="PickupTime" caption="ATA" allowSearch={true} allowFiltering={false} allowSorting={true} dataType="datetime" format=" HH:mm" width={90} /> */}
                      <Template
                        name="toolbarDataFilterTemplate"
                        render={() => {
                          return (
                            <>
                              <span>
                                <i className={`fas fa-clock`}></i>{" "}
                                {this.state.reservationTitle}
                                <span className="ml-2">
                                  [{" "}
                                  {moment(this.state.filterFromDatetime).format(
                                    `DD/MM/yyyy HH:mm`,
                                  )}
                                  {" - "}
                                  {moment(this.state.filterToDatetime).format(
                                    `DD/MM/yyyy HH:mm`,
                                  )}{" "}
                                  ]
                                </span>
                              </span>
                            </>
                          );
                        }}
                      />
                      <Template
                        name="toolbarDataDutyTypeDropdownTemplate"
                        render={() => {
                          return (
                            <>
                              <SelectBox
                                dataSource={DutyTypeLst}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Select duty type"
                                name="dutyTypeDropdown"
                                defaultValue={0}
                                value={this.state.dutyTypeId}
                                displayExpr="name"
                                valueExpr="id"
                                onValueChanged={(e) => {
                                  try {
                                    let dutyTypeId = e.value ?? 0;
                                    this.setState((prev) => ({
                                      ...prev,
                                      dutyTypeId: dutyTypeId,
                                    }));
                                    this.filterTripDataGridDutyTypeWise(
                                      dutyTypeId,
                                      this.state.timeSlotId,
                                      this.state.tripLst,
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                showClearButton={true}
                                searchEnabled={true}
                              />
                            </>
                          );
                        }}
                      />
                      <Template
                        name="toolbarTimeSlotDropdownTemplate"
                        render={() => {
                          return (
                            <>
                              <SelectBox
                                dataSource={TimeSlotList}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="All Time"
                                name="timeSlotDropdown"
                                width={165}
                                defaultValue={0}
                                value={this.state.timeSlotId}
                                displayExpr="name"
                                valueExpr="id"
                                onValueChanged={(e) => {
                                  try {
                                    const timeSlotId = e.value ?? 0;
                                    this.setState((prev) => ({
                                      ...prev,
                                      timeSlotId: timeSlotId,
                                    }));
                                    this.filterTripDataGridDutyTypeWise(
                                      this.state.dutyTypeId,
                                      timeSlotId,
                                      this.state.tripLst,
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                showClearButton={true}
                                searchEnabled={false}
                              />
                            </>
                          );
                        }}
                      />
                      <HeaderFilter visible={true} />
                      <Paging defaultPageSize={10} />
                      <Pager
                        displayMode="compact"
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50]}
                        showInfo={true}
                        visible={true}
                      />
                      <SearchPanel
                        visible={true}
                        highlightCaseSensitive={true}
                        width={240}
                        placeholder="Search..."
                      />
                      <Export
                        enabled={true}
                        allowExportSelectedData={false}
                        fileName="CrewActivity"
                      />
                    </DataGrid>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          position={{ of: "#historydiv" }}
          visible={this.state.loadPanelVisible}
          showIndicator={true}
          shading={true}
          showPane={true}
          closeOnOutsideClick={false}
        />
      </>
    );
  }
}
export function BookingSummaryCount() {
  return (
    <>
      {[...Array(8)].map((_, index) => (
        <div key={index} className="col-12 col-sm-6 col-md-3 px-2">
          <div
            className="card border-0 mb-2 db-summary-card"
            style={{
              background: "#e9ecef",
              boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
            }}
          >
            <div className="card-body d-flex align-items-center gap-3 p-3">
              <div
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  background: "rgba(0,0,0,0.08)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Skeleton circle width={40} height={40} />
              </div>
              <div>
                <div style={{ marginBottom: 6 }}>
                  <Skeleton width={110} height={12} />
                </div>
                <div>
                  <Skeleton width={50} height={22} />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
